<template>
	<!-- 修改密码  -- 保存-->
	<div class="aboutYjBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">修改密码</p>
				</div>
			</div>
		</van-sticky>
		<div class="bcpasswordBox">
			<div>
				<span>输入原始密码</span>
				<input type="text" placeholder="输入原始密码" v-model="ysPassword">
			</div>
			<div>
				<span class="newpassword">新密码</span>
				<input type="text" placeholder="6~16个字符，区分大小写" v-model="newPassword"/>
			</div>
			<div>
				<span>再次输入新密码</span>
				<input type="text" placeholder="请再次输入新密码" v-model="queryPassword"/>
			</div>
		</div>
		
		<div class="btn">
			<img src="../../assets/img/flower.png" alt="" class='flower'>
			<button @click="submitFn">保存</button>
		</div>
	</div>
</template>

<script>
	import {Toast} from 'vant'
	export default {
		data() {
			return {
				userInfoData:{},
				ysPassword: '',
				newPassword: '',
				queryPassword:'',
			}
		},
		created() {
			this.userInfoData = JSON.parse(localStorage.getItem('userInfoData'))
		},
		methods: {
			back() {
				this.$router.push('/set')
			},
			submitFn(){
				if(this.ysPassword == ''){
					Toast('请输入原始密码')
					return false
				}else if(this.newPassword == ''){
					Toast('请输入新密码')
					return false
				}else if(this.queryPassword != this.newPassword){
					Toast('请重新确认新密码')
					return false
				}
				this.$axios.post(this.$api.reset_pwd,{
					password: this.ysPassword,
					new_password: this.newPassword,
					new_password_again: this.queryPassword,
				}).then(res =>{
					Toast(res.data.msg)
					if(res.data.msg == '修改成功'){
						// this.$router.push('/querypassword')
						this.$router.push('/set')
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.aboutYjBox{
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88%;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		
		.bcpasswordBox{
			padding-top: 20px;
			font-size: 30px;/*px*/
			div{
				display: flex;
				line-height: 80px;
				padding: 0 20px;
				margin-top:10px;
				background-color: #fff;
				input{
					width: 65%;
				}
				span{
					flex:1;
				}
			}
		}
		.btn{
			text-align: center;
			margin-top: 180px;
			position: relative;
			.flower{
				position: absolute;
				top: -60px;
				left: 60%;
				width: 100px;
			}
			button{
				border: 0;
				line-height: 80px;
				font-size: 32px;/*px*/
				width: 90%;
				background-color: #FF4081;
				color:#fff;
				border-radius: 10px;
			}
		}
	}

</style>
